'use client';

import { type ReactElement } from 'react';

type Props = {
	widthPct: number;
	offsetPct: number;
};

export default function CarouselSlider({ widthPct, offsetPct }: Props): ReactElement {
	return (
		<div className="relative h-020 w-full bg-border-subtle" aria-hidden="true">
			<div
				className="absolute top-0 h-020 bg-border-strong"
				style={{ width: `${widthPct}%`, left: `${offsetPct}%` }}
			/>
		</div>
	);
}
